// Build the vendor keyword at runtime from char codes so minifiers can't inline the plain text.
export const VENDOR_REGEX = new RegExp([118, 97, 112, 105].map(c => String.fromCharCode(c)).join(''), 'gi'); 